import React from "react";
import PricingBody from "./PricingBody";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";

function PricingMain() {
  return (
    <div style={{ marginTop: "7rem" }}>
      {/*Firebase analytics */}
      {logEvent(analytics, "Pricing Screen")}

      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Pricing body */}
      <PricingBody />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PricingMain;
